module.exports = __webpack_public_path__ + "fonts/Segoe-UI.4547228.ttf";